
    import React from 'react';
    import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
    import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
    import SpriteSymbolComponent from "../../../../../tools/webpack/svgSpriteLoader/icon.tsx";

    const symbol = new SpriteSymbol({
  "id": "like_16_light_lYjW4",
  "use": "like_16_light_lYjW4-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"like_16_light_lYjW4\">\n<defs>\n<linearGradient id=\"like_16_light_lYjW4_like_gradient_light_16\" x1=\"0\" y1=\"0\" x2=\"16\" y2=\"16\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#66ADFF\" />\n<stop offset=\"1\" stop-color=\"#0077FF\" />\n</linearGradient>\n</defs>\n<circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"url(#like_16_light_lYjW4_like_gradient_light_16)\" />\n<path d=\"M9.7594 5.20001C10.9968 5.20001 12 6.16391 12 7.35294C12 8.55372 11.4993 9.15577 9.3756 10.7429L8.40929 11.4651C8.16855 11.645 7.83145 11.645 7.59071 11.4651L6.6244 10.7429C4.50069 9.15577 4 8.55372 4 7.35294C4 6.16391 5.00315 5.20001 6.2406 5.20001C6.90359 5.20001 7.48 5.52001 8 6.12001C8.52 5.52001 9.09641 5.20001 9.7594 5.20001Z\" fill=\"white\" />\n</symbol>"
});
    sprite.add(symbol);

    const Like_16LightLYjW4SpriteSymbolComponent = props => {
      return React.createElement(SpriteSymbolComponent, {glyph: "like_16_light_lYjW4", width: 16, height: 16, ...props })
    }

    export { Like_16LightLYjW4SpriteSymbolComponent as ReactComponent };
  